const estilo_coluna_fixo = {
  backgroundColor: 'white',
  position: 'sticky !important',
  zIndex: '1 !important',
}

export default [
  {
    text: "Grupo",
    value: "sigla_grupo",
    sortable: false,
    ativa: true,
    fixa: true,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '80px',
      maxWidth: '80px',
      left: '32px',
      right: 'auto',
      borderRight: '2px solid rgba(0,0,0,.1)',
      cursor: 'pointer',
    },
    customColumnDisabled: true
  },
  {
    text: "ABC F.",
    value: "classificacao_criticidade",
    ordenacao_combinada: true,
    inverter_ordenacao: true,
    sortable: false,
    style: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      borderRight: '2px solid rgba(0,0,0,.1)',
    },
    customColumnDisabled: true
  },
  {
    text: "ABC R.",
    value: "classificacao_rentabilidade",
    ordenacao_combinada: true,
    sortable: false,
    style: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      borderRight: '2px solid rgba(0,0,0,.1)',
    },
    customColumnDisabled: true
  },
  {
    text: "Fornecedor",
    value: "razao_social",
    style: {
      minWidth: '100px',
      maxWidth: '200px',
      cursor: 'pointer',
    }
  },
  {
    text: "Cód. Int",
    value: "idproduto",
    style: {
      minWidth: '75px',
      cursor: 'pointer',
    }
  },
  {
    text: "Cód Fornecedor",
    value: "cod_produto",
    style: {
      minWidth: '120px',
      maxWidth: '120px',
      cursor: 'pointer',
    }
  },
  {
    text: 'Número Original',
    value: 'numero_original',
    style: {
      minWidth: '120px',
      maxWidth: '120px',
      cursor: 'pointer',
    }
  },
  {
    text: "Descrição Produto",
    value: "descricao_produto",
    style: {
      minWidth: '180px',
      cursor: 'pointer',
    }
  },
  {
    text: "UND",
    value: "unidade_compra",
    style: {
      cursor: 'pointer',
    }
  },
  {
    text: "Dias Gatilho",
    value: "tempo_gatilho",
    style: {
      minWidth: '80px',
      maxWidth: '80px',
      cursor: 'pointer',
    }
  },
  {
    text: "Estoque Atual",
    value: "estoque",
    align: 'center',
    style: {
      minWidth: '95px',
      maxWidth: '95px',
      cursor: 'pointer',
    }
  },
  {
    text: "Cobertura Est. Futura",
    value: "cobertura_est_futura",
    sortable: false,
    style: {
      minWidth: '130px',
      maxWidth: '130px',
    }
  },
  {
    text: "Linha do Produto",
    value: "descricao_linha",
    style: {
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    }
  },
  {
    text: "Preço compra",
    value: "preco_compra",
    sortable: false,
    style: {
      minWidth: '100px',
      maxWidth: '100px',
    }
  },
  {
    text: "Sugestão em galão",
    value: "sugestao_em_litragem",
    sortable: false,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Compra em pallet',
    value: 'compra_em_palete',
    style: {
      minWidth: '165px',
      maxWidth: '165px',
    }
  },
  {
    text: "Sugestão",
    value: "sugestao",
    ativa: true,
    fixa: true,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '180px',
      maxWidth: '180px',
      right: '0',
      left: 'auto',
      paddingLeft: '11px',
      borderLeft: '2px solid rgba(0,0,0,.1)',
      cursor: 'pointer',
    },
    // customColumnDisabled: true
  }
]
